define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader', 'router', 'scroll'],
    function ($, transit, modernizr, container, preloader, router, scroll) {

        var module = (function () {

            var name = 'module-brand-solution-digital-social-gaming-featured';

            var model = container.getBaseModel(name);
            var view = container.getBaseView(name);
            var pubSub = container.getPublishSubscribe();
            /* model */

            model.publicVars = {};

            model.privateVars = {};

            model.methods = {

            }

            /* view */

            view.publicVars = {};

            view.privateVars = {
                categoryActive: 1,
                categoryAnim: 0
            };

            view.startup = function () {
                // scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleBrandSolutionDigitalSocialGamingFeaturedHeaderMenuId, 'animate__faster animate__fadeIn', 'brand-solution-digital-social-gaming-featured', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleBrandSolutionDigitalSocialGamingFeaturedCategoryWrapperId, 'animate__faster animate__zoomIn', 'brand-solution-digital-social-gaming-featured', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleBrandSolutionDigitalSocialGamingFeaturedAnimMainId, 'animate__faster animate__slideInLeft', 'brand-solution-digital-social-gaming-featured', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleBrandSolutionDigitalSocialGamingFeaturedAnimBoxId, 'animate__faster animate__slideInRight', 'brand-solution-digital-social-gaming-featured', {});
            };

            view.bind = function () {
                $(view.publicVars.cssId.moduleBrandSolutionDigitalSocialGamingFeaturedCategoryCls).click(function () {
                    if(!view.privateVars.categoryAnim) {
                        view.privateVars.categoryAnim = 1;
                        view.methods.handleCategoryClick(this);
                    }
                });
            };

            view.methods = {
                handleCategoryClick: (handler) => {
                    const id = container.getData($(handler)[0], 'id');
                    let info = $(view.publicVars.cssId.moduleBrandSolutionDigitalSocialGamingFeaturedCategoryInfoTemplateId + id).html();

                    if(view.privateVars.categoryActive == id) {
                        view.privateVars.categoryAnim = 0;
                        return;
                    }


                    $(view.publicVars.cssId.moduleBrandSolutionDigitalSocialGamingFeaturedCategoryCls).removeClass(view.publicVars.cssId.isActiveCls.substr(1));
                    $(handler).addClass(view.publicVars.cssId.isActiveCls.substr(1));

                    const currentHeight = $(view.publicVars.cssId.moduleBrandSolutionDigitalSocialGamingFeaturedCategoryContentInnerCls).outerHeight();

                    $(view.publicVars.cssId.moduleBrandSolutionDigitalSocialGamingFeaturedCategoryContentInnerCls).css({ height: currentHeight + 'px'});

                    $(view.publicVars.cssId.moduleBrandSolutionDigitalSocialGamingFeaturedCategoryContentInnerCls).transit({ opacity: 0 }, 300, function () {
                        $(view.publicVars.cssId.moduleBrandSolutionDigitalSocialGamingFeaturedCategoryContentInnerCls).html(info);
                        $(view.publicVars.cssId.moduleBrandSolutionDigitalSocialGamingFeaturedCategoryContentInnerCls).removeAttr('style');
                        const newHeight = $(view.publicVars.cssId.moduleBrandSolutionDigitalSocialGamingFeaturedCategoryContentInnerCls).outerHeight();
                        $(view.publicVars.cssId.moduleBrandSolutionDigitalSocialGamingFeaturedCategoryContentInnerCls).css({ opacity: 0, height: currentHeight + 'px' });
                        $(view.publicVars.cssId.moduleBrandSolutionDigitalSocialGamingFeaturedCategoryContentInnerCls).html('');

                        let speed = 300;

                        if(newHeight == currentHeight) {
                            speed = 0;
                        }

                        $(view.publicVars.cssId.moduleBrandSolutionDigitalSocialGamingFeaturedCategoryContentInnerCls).transit({ height: newHeight }, speed, function () {
                            $(view.publicVars.cssId.moduleBrandSolutionDigitalSocialGamingFeaturedCategoryContentInnerCls).html(info);
                            $(view.publicVars.cssId.moduleBrandSolutionDigitalSocialGamingFeaturedCategoryContentInnerCls).css({ scale: 0.5 });
                            $(view.publicVars.cssId.moduleBrandSolutionDigitalSocialGamingFeaturedCategoryContentInnerCls).transit({scale: 1, opacity: 1}, 300, function () {
                                view.privateVars.categoryActive = id;
                                view.privateVars.categoryAnim = 0;
                                $(view.publicVars.cssId.moduleBrandSolutionDigitalSocialGamingFeaturedCategoryContentInnerCls).removeAttr('style');
                            });
                        });
                    });
                }
            };

            /* custom events */
            //pubSub.subscribe('view/actionShowFormThx', view.methods.actionShowFormThx);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    view.init(options);
                    scroll.init();
                }
            };


        })();

        return module;


    });
